import { Slider } from '@/global/components/ui/slider'
import { useFormContext } from 'react-hook-form'

export default function SliderDias() {
    const { watch, setValue } = useFormContext()
    const value = watch('maximoDiasCompetencia')

    return (
        <div className="flex flex-row gap-4 items-center flex-grow">
            <div className="flex flex-col gap-2 w-full">
                <span className="text-xs select-none">
                    Máximo de dias na competência atual
                </span>
                <Slider
                    min={15}
                    max={45}
                    step={1}
                    onValueChange={v =>
                        setValue('maximoDiasCompetencia', v.at(0))
                    }
                    value={[value]}
                    className="min-w-full"
                />
            </div>
            <span className="text-md">{value}</span>
        </div>
    )
}
